import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Toaster } from 'sonner'
import { WalletProvider } from '@/providers/wallet-provider'
import App from './App'
import './index.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <WalletProvider>
      <App />
      <Toaster theme="dark" richColors position="bottom-right" />
    </WalletProvider>
  </StrictMode>,
)
